import { AxiosResponse } from "axios";
import { InstanceChoice } from "../model/Instance";
import { getAxiosInstance } from "./api-utils";
import { setSelectedInstanceId } from "@/generic/authStore";

const AUTHENTICATION = "/authentication";

/** Instances the signed-in user may act in (Keycloak owns auth; this is membership). */
export async function GetInstances() {
    const response: AxiosResponse<InstanceChoice[]> = await getAxiosInstance().get(AUTHENTICATION + "/instances");
    return response.data;
}

/** Persist the chosen instance locally — sent as X-Instance-Id on every request
 *  and validated server-side. (No server round-trip: the token is from Keycloak.) */
export async function SetInstance(instanceId: number) {
    setSelectedInstanceId(instanceId);
}
